<template>
  <div id="app">
    <div class="body_bg">
      <div class="container whitebg pd15">
        <el-row :gutter="25">
          <Mlogin />
         <el-col :xs="24" :sm="24" :md="19" :lg="19" :xl="19" class="main-content">
            <div class="grid-content bg-purple-light">
              <div class="side_con">
                <div class="title_all" style="margin-bottom: 0">
                  <div class="title_left">Advanced Search </div>
                  <div class="title_more2">
                    <a href="/EN">Home</a>>Advanced Search 
                  </div>
                  <div class="clearfix"></div>
                </div>
                <div class="side_container">
                  <!-- 模块（标题等等） -->
                  <div class="high_table fifth" style="margin-left: 10px">
                    <div v-for="(item, i) in searchKey" :key="i" :class="{ five: i > 0 }">
                      <span class="leftfloat" v-show="i > 0" style="margin-right: 5px">
                        <el-select v-model="item.Join" placeholder="Or" style="width: 60px">
                          <el-option value="And">And</el-option>
                          <el-option value="Or">Or</el-option>
                        </el-select>
                      </span>
                      <span class="leftfloat ml1" :style="{ marginLeft: i > 0 ? '0' : '65px' }">
                        <el-select v-model="item.Type" placeholder="title" style="width: 90px">
                          <el-option v-for="(t, m) in typeMode" :key="m" :value="t.key" :selected="item.type == t.key">
                            {{ t.label }}</el-option>
                        </el-select>
                      </span>
                      <span class="leftfloat ml1"><el-input v-model="item.Key" style="width: 390px"
                          placeholder="Input please"></el-input></span>
                      <div>
                        <span class="pull-left ml1" v-if="i <= 0">
                          <el-button @click="add" type="primary"><el-icon><Plus /></el-icon></el-button>
                        </span>
                        <span class="pull-left ml1" v-show="i > 0">
                          <el-button @click="del(i)"><el-icon><Minus /></el-icon></el-button>
                        </span>
                      </div>
                      <div class="clearfix"></div>
                    </div>
                  </div>

                  <div class="table_box2 fifth">
                    <table width="100%" border="0" cellspacing="0" cellpadding="0" class="table_card">
                      <tbody>
                        <tr style="border-bottom: 1px #dbdbdb solid" v-if="islingyu && Sublist && Sublist.length > 0">
                          <td width="14%" align="right" style="padding-right: 15px" bgcolor="#f4f4f4"
                            class="highsearch_title">
                            <el-checkbox :indeterminate="xkly" v-model="Subject"
                              @change="handleCheckAllChange('n')">Field</el-checkbox>
                          </td>
                          <td colspan="3" width="78%" style="padding-left: 15px">
                            <el-tooltip v-for="(item, index) in Sublist" class="item" effect="dark" :key="index"
                              :enterable="false" :content="item.ItemNameE" placement="top">
                              <el-checkbox @change="chanhidSub" style="width: 140px; text-overflow: ellipsis"
                                :label="item.ItemID" v-model="item.checked" :title="item.ItemNameE">{{ item.ItemNameE
                                }}</el-checkbox>
                            </el-tooltip>
                            <div class="clear"></div>
                          </td>
                        </tr>

                        <tr style="border-bottom: 1px #dbdbdb solid"
                          v-if="islanmu && cloumnlist && cloumnlist.length > 0">
                          <td width="14%" align="right" style="padding-right: 15px" bgcolor="#f4f4f4"
                            class="highsearch_title">
                            <el-checkbox :indeterminate="lmly" v-model="cloumnject" style="margin-right: 28px"
                              @change="handleCheckAllChange('cloumn')">Column</el-checkbox>
                          </td>
                          <td colspan="3" width="78%" style="padding-left: 15px">
                            <div style="height: 88px; overflow: hidden" ref="hids">
                              <label style="margin-right: 30px" v-for="(item, index) in cloumnlist" class="item"
                                effect="dark" :enterable="false" :key="index" placement="top">
                                <el-checkbox @change="chanhidcloumn" class="box" style="width: 140px; overflow: hidden"
                                  :label="item.ItemID" v-model="item.checked" :title="item.ItemNameE">{{ item.ItemNameE
                                  }}</el-checkbox>
                              </label>
                            </div>
                            <a href="javascript:;" ref="hid" @click="hidtable" v-if="cloumnlist.length > 12">Show
                              hide</a>
                            <div class="clear"></div>
                          </td>
                        </tr>

                        <tr style="border-bottom: 1px #dbdbdb solid" class="Annual">
                          <td width="14%" align="right" style="padding-right: 15px" bgcolor="#f4f4f4"
                            class="highsearch_title">
                            <el-checkbox v-model="yeahject" @change="chanhidYears">Publish year</el-checkbox>
                          </td>
                          <td colspan="3" width="78%" style="padding-left: 15px">
                            <span>
                              <el-radio v-model="radio" label="1" @change="chanhidYear">Given Year</el-radio>
                              <!-- <el-date-picker
  						        v-model="value1"
  						        type="year"
  						        placeholder="选择年度">
  						      </el-date-picker> -->
                              <span class="posirelative select-out-div">
                                <select class="m-wrap" style="
                                    padding: 2px 0;
                                    width: 140px;
                                    height: 30px;
                                    border-radius: 4px;
                                  " v-model="Year" @change="changeyearList">
                                  <option value="" disabled="disabled">
                                    Year
                                  </option>
                                  <option v-for="(item, index) in yearlist" :value="item" :key="index">
                                    {{ item }}
                                  </option>
                                </select>
                              </span>
                            </span>
                            <span class="ml15">
                              <el-radio v-model="radio" label="2" @change="chanhidYear">Year Range</el-radio>
                              <span class="posirelative select-out-div">
                                <select class="m-wrap" style="
                                    padding: 2px 0;
                                    width: 163px;
                                    height: 30px;
                                    border-radius: 4px;
                                  " v-model="YearStart" @change="changeyearLista">
                                  <option value="" disabled="disabled">
                                    Start year
                                  </option>
                                  <option v-for="(item, index) in yearlist" :value="item" :key="index">
                                    {{ item }}
                                  </option>
                                </select> </span>-
                              <span class="posirelative select-out-div">
                                <select class="m-wrap" style="
                                    padding: 2px 0;
                                    width: 163px;
                                    height: 30px;
                                    border-radius: 4px;
                                  " v-model="YearEnd" @change="changeyearListb">
                                  <option value="" disabled="disabled">
                                    End year
                                  </option>
                                  <option v-for="(item, index) in yearlist" :value="item" :key="index">
                                    {{ item }}
                                  </option>
                                </select>
                              </span>
                            </span>
                          </td>
                        </tr>

                        <tr style="border-bottom: 1px #dbdbdb solid" class="Annual">
                          <td width="14%" align="right" style="padding-right: 15px" bgcolor="#f4f4f4"
                            class="highsearch_title">
                            <el-checkbox v-model="textject" class="fulltext"
                              @change="chanhids()">Fulltext&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</el-checkbox>
                          </td>
                          <td colspan="3" width="78%" style="padding-left: 15px">
                            <span>
                              <el-radio v-model="radios" label="1" @change="chanhid()">Unlimited</el-radio>
                            </span>
                            <span class="ml15">
                              <el-radio v-model="radios" label="2" @change="chanhid()">Free Fulltext</el-radio>
                            </span>
                            <span class="ml15">
                              <el-radio v-model="radios" label="3" @change="chanhid()">Fulltext</el-radio>
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div class="highsearch_button fifth">
                      <div class="leftfloat" style="width: 15%">&nbsp;</div>
                      <div class="leftfloat">
                        <el-button type="primary" @click="Search"
                          style="padding: 12px 35px; margin-right: 15px">Search</el-button>
                        <a @click="goeasy">Simple Search</a>
                      </div>
                      <div class="clearfix"></div>
                    </div>
                  </div>
                  <div v-loading="loading" style="margin-top: 20px">
                    <div class="msg_error" v-show="showErr">
                      No result found.
                    </div>
                    <div class="fifth" v-if="tabcontent.length > 0">
                      <article-list :List="tabcontent" :ischeckbox="true" :iscount="indexs" :count="indexs" :type="0"
                        :allcheckedshow="true" @allchecked="allchecked">
                      </article-list>
                    </div>
                  </div>
                </div>
                <div v-if="indexs > 0">
                  <common-page :count="indexs" @pageSize="pageSize" @pageindex="index" :index="paramas"></common-page>
                </div>
              </div>
            </div>
          </el-col>
          <DocumentsNewsBlockControl />
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      cloumnlist: [], //栏目
      cloumnject: false, //栏目确定
      checkedlist: [], //栏目
      paramas: {
        PageSize: 10,
        PageIndex: 0,
        IssueId: 0,
      },
      textject: false, //文本确定
      radios: false,
      islanmu: false,
      islingyu: false,
      yeahject: false, //年度确定
      radio: false, //年度类型
      Year: '', //固定年度
      YearStart: '', //区间年度
      YearEnd: '',
      lmly: false,
      xkly: false,
      Sublist: [], //学科
      Subject: false, //学科确定
      checkedSublist: [], //栏目
      disabled: false,
      indexs: 0,
      searchKey: [
        {
          Type: 'Title',
          Key: '',
          Join: 'Or',
        },
        {
          Type: 'Title',
          Key: '',
          Join: 'Or',
        },
      ],
      typeMode: [
        {
          key: 'Title',
          label: 'Title',
        },
        {
          key: 'Author',
          label: 'Author',
        },
        {
          key: 'Abstract',
          label: 'Abstract',
        },
        {
          key: 'Keyword',
          label: 'Keyword',
        },
        {
          key: 'Unit',
          label: 'Unit',
        },
      ],
      size: 1,
      num: 10,
      tabcontent: [],
      showErr: false, //无数据提示
      loading: false,
      yearlist: [],
    }
  },
  async created() {
    let [Sublist, cloumnlist] = await Promise.all([
      this.$store.dispatch('_getgok'),
      this.$store.dispatch('_getLM'),
    ])

    if (Sublist.data.Data.Field) {
      this.Sublist = Sublist.data.Data.Field
    } else {
      this.Sublist = []
    }
    if (cloumnlist.data.Data) {
      this.cloumnlist = cloumnlist.data.Data
    } else {
      this.cloumnlist = []
    }
    this.$store.dispatch('_postNDCJ').then((res) => {
      this.yearlist = res.data.Data
    })
    //判断系统设置的领域是否隐藏
    if (sessionStorage.getItem('SetItem')) {
      let SetItem = JSON.parse(sessionStorage.getItem('SetItem'))
      SetItem.map((item) => {
        if (item.SetItemID == 99) {
          if (item.Item_Value == '是') {
            this.islingyu = true
          } else {
            this.islingyu = false
          }
        }
        if (item.SetItemID == 96) {
          if (item.Item_Value == '是') {
            this.islanmu = true
          } else {
            this.islanmu = false
          }
        }
      })
    } else {
      let params = [
        1000, 1001, 4530, 6018, 6019, 230, 6055, 5000, 5010, 99, 2960, 4553,
      ]
      //1000:期刊名称
      //1001：期刊英文名称
      //4530：（否）隐藏/（是）显示预出版模块
      //6018:预出版模块显示 （否）文章列表/（是）预出版内容
      //6019：是否需要登录下载文件
      //230：显示/隐藏所有的评论功能
      //6055：显示/隐藏列表和详情页的英文标题，英文关键字，英文摘要
      //5000： ISSN编号
      //5010：CN编号
      this.$store.dispatch('_getSet', params).then((res) => {
        sessionStorage.setItem('SetItem', JSON.stringify(res.data.Data))
        let SetItem = res.data.Data
        SetItem.map((item) => {
          if (item.SetItemID == 99) {
            if (item.Item_Value == '是') {
              this.islingyu = true
            } else {
              this.islingyu = false
            }
          }
          if (item.SetItemID == 96) {
            if (item.Item_Value == '是') {
              this.islanmu = true
            } else {
              this.islanmu = false
            }
          }
        })
      })
    }
  },
  methods: {
    allchecked() {
      this.tabcontent.map((item) => {
        item.checked = true
      })
    },
    hidtable() {
      if (this.$refs.hid.innerHTML == 'Show hide') {
        this.$refs.hid.innerHTML = 'hide'
        this.$refs.hids.style.height = ''
        this.$refs.hids.style.overflow = ''
      } else {
        this.$refs.hid.innerHTML = 'Show hide'
        this.$refs.hids.style.height = '88px'
        this.$refs.hids.style.overflow = 'hidden'
      }
    },
    handleCheckAllChange(str) {
      if (str == 'cloumn') {
        if (this.cloumnject == true) {
          this.lmly = false
          this.cloumnject = true
          if (this.cloumnlist.length > 0) {
            this.cloumnlist.map((item) => {
              item.checked = true
            })
          }
        } else {
          this.lmly = false
          if (this.cloumnlist.length > 0) {
            this.cloumnlist.map((item) => {
              item.checked = false
            })
          }
        }
      } else {
        if (this.Subject == true) {
          this.xkly = false
          this.Subject = true
          if (this.Sublist.length > 0) {
            this.Sublist.map((item) => {
              item.checked = true
            })
          }
        } else {
          this.xkly = false
          if (this.Sublist.length > 0) {
            this.Sublist.map((item) => {
              item.checked = false
            })
          }
        }
      }
    },
    goeasy() {
      if (localStorage.getItem('value')) {
        localStorage.setItem('value', '')
        let routeData = this.$router.resolve('/QuickSearch')
        window.open(routeData.href, '_blank')
      } else {
        let routeData = this.$router.resolve('/QuickSearch')
        window.open(routeData.href, '_blank')
      }
    },
    chanhidYears(str) {
      if (this.yeahject == true) {
        this.yeahject = true
        this.radio = '1'
      } else {
        this.yeahject = false
        this.radio = false
        this.YearStart = ''
        this.YearEnd = ''
        this.Year = ''
      }
    },
    chanhids(str) {
      if (this.textject == true) {
        this.radios = '1'
      } else {
        this.radios = false
      }
    },
    chanhidcloumn(str) {
      let index = 0
      let indexs = 0
      this.lmly = false
      this.cloumnject = false
      if (this.cloumnlist.length > 0) {
        this.cloumnlist.map((item) => {
          if (item.checked) {
            this.lmly = true
            indexs = 1
          } else {
            index = 1
          }
        })
        if (indexs == 1 && index == 0) {
          this.lmly = false
          this.cloumnject = true
        } else if (index == 1 && indexs == 1) {
          this.lmly = true
        } else {
          this.lmly = false
        }
      }
    },
    chanhidSub(str) {
      let index = 0
      let indexs = 0
      this.xkly = false
      this.Subject = false
      if (this.Sublist.length > 0) {
        this.Sublist.map((item) => {
          if (item.checked) {
            this.Subject = true
            indexs = 1
          } else {
            index = 1
          }
        })
        if (indexs == 1 && index == 0) {
          this.cloumnject = true
          this.xkly = false
        } else if (index == 1 && indexs == 1) {
          this.xkly = true
        } else {
          this.xkly = false
        }
      }
    },
    chanhidYear(str) {
      this.yeahject = true
    },
    chanhid(str) {
      this.textject = true
    },
    changeyearList() {
      if (this.Year != '') {
        this.radio = '1'
        this.yeahject = true
        this.YearStart = ''
        this.YearEnd = ''
      }
    },

    changeyearLista() {
      if (this.YearStart != '') {
        this.radio = '2'
        this.yeahject = true
        this.Year = ''
      }
    },
    changeyearListb() {
      if (this.YearEnd != '') {
        if (parseInt(this.YearEnd) < parseInt(this.YearStart)) {
          alert('End year can not be less than  start year')
          this.YearEnd = ''
        } else {
          this.radio = '2'
          this.yeahject = true
          this.Year = ''
        }
      }
    },
    //搜索
    async Search(val) {
      this.loading = true
      //头部部分
      let search = []
      for (let i = 0; i < this.searchKey.length; i++) {
        let Join = ''
        if (this.searchKey[i].Join == 'And') {
          Join = 'And'
        } else {
          Join = 'Or'
        }
        if (i == 0) {
          let Type = ''
          switch (this.searchKey[i].Type) {
            case 'Title':
              Type = 'Title'
              break
            case 'Authors':
              Type = 'Author'
              break
            case 'Keywords':
              Type = 'Keyword'
              break
            case 'Abstract':
              Type = 'Abstract'
              break
            case '单位':
              Type = 'Unit'
              break
          }
          search.push({
            Type: Type,
            Key: this.searchKey[i].Key,
          })
        } else {
          let Type = ''
          switch (this.searchKey[i].Type) {
            case 'Title':
              Type = 'Title'
              break
            case 'Author':
              Type = 'Author'
              break
            case 'Keywords':
              Type = 'Keyword'
              break
            case 'Abstract':
              Type = 'Abstract'
              break
            case '单位':
              Type = 'Unit'
              break
          }
          search.push({
            Type: Type,
            Key: this.searchKey[i].Key,
            Join: Join,
          })
        }
      }
      //学科部分
      let Sub = []
      if (this.Sublist.length > 0) {
        this.Sublist.map((item) => {
          if (item.checked) {
            Sub.push(item.ItemID)
          }
        })
      }

      //栏目部分
      let cloumnIds = []
      if (this.cloumnlist) {
        this.cloumnlist.map((item) => {
          if (item.checked) {
            cloumnIds.push(item.ItemID)
          }
        })
      }

      //年度部分
      if (this.yeahject) {
        if (this.radio == 2) {
          //年度判断
          if (this.YearStart == '') {
            alert('Select start year please')
            return
          } else if (this.YearEnd == '') {
            alert('Select end year please')
            return
          } else if (parseInt(this.YearStart) > parseInt(this.YearEnd)) {
            alert('End year can not be less than  start year')
            return
          }
          var YearStart = this.YearStart
          var YearEnd = this.YearEnd
        } else if (this.radio == 1) {
          if (this.Year.length != 0) {
            var d3 = this.Year
          } else {
            alert('Please select year')
            return
          }
        }
      }

      //文本领域
      if (this.textject) {
        var radios = ''
        radios = this.radios - 1
      }
      let params = {
        PageIndex: this.paramas.PageIndex,
        PageSize: this.paramas.PageSize,
        SearchKey: search,
        ColunmIds: cloumnIds,
        FieldIds: Sub,
        Year: d3,
        YearStart: YearStart,
        YearEnd: YearEnd,
        IsFull: radios,
      }
      let Res = await this.$store.dispatch('_postSearch', params)
      if (Res.data.ItemCount > 0) {
        Res.data.Data.map((item) => {
          item.checked = false
        })
        this.tabcontent = Res.data.Data
        this.indexs = Res.data.ItemCount
        this.showErr = false
        console.log(this.searchKey, '112')
        this.tabcontent.forEach((item) => {
          this.searchKey.forEach((val) => {
            if (val.Type == 'Title' || val.Type == 'Keywords') {
              item.TitleE = this.$brightkeyWords(item.TitleE, val.Key)
            }
            if (val.Type == 'Authors') {
              item.AuthorsListE = this.$brightkeyWords(
                item.AuthorsListE,
                val.Key
              )
            }
          })
        })
      } else {
        this.showErr = true
        //初始化内容
        this.tabcontent = []
        this.indexs = 0
      }
      this.loading = false
    },
    async pageSize(val) {
      //页面条数
      this.paramas.PageSize = val
      this.Search(val)
    },
    async index(val) {
      //页面位数
      this.paramas.PageIndex = val
      this.Search(val)
    },
    //导出选中
    postGoin() {
      let ids = ''
      this.tabcontent.map((item) => {
        if (item.checked) {
          ids += item.ArticleID + ','
        }
      })
      var arr = ids.split('')
      arr.splice(arr.length - 1, 1)
      ids = arr.join('')
      this.$newOpen('/#/Export?ids=' + ids)
    },
    //增加搜索框
    add() {
      var searchKeyLength = this.searchKey.length
      if (searchKeyLength === 19) {
        alert('20 search Items at most')
        this.$refs.dis.disabled = true
      } else {
        this.searchKey.push({
          Type: 'Title',
          Key: '',
          Join: 'And',
        })
      }
    },
    //删除搜索框
    del(i) {
      var searchKeyLength = this.searchKey.length
      if (searchKeyLength < 2) {
        return false
      }
      this.searchKey.splice(i, 1)
    },
  },
}
</script>

<style>
.side_container {
  line-height: 16px;
}

.el-tooltip>span[.el-checkbox__label] {
  text-overflow: ellipsis;
  overflow: hidden;
  width: 116px;
}

.posirelative {
  position: relative;
}

.select-out-div {
  width: 160px;
  overflow: hidden;
}

select.m-wrap {
  color: #606266;
  background-color: #ffffff;
  background-image: none !important;
  filter: none !important;
  border: 1px solid #e5e5e5;
  outline: none;
  height: 32px !important;
  line-height: 25px;
}

.select-hide-span {
  height: 25px;
  position: absolute;
  top: 0;
  border-right: 1px solid #e5e5e5;
  right: 0;
  width: 20px !important;
  z-index: 999;
}

.select-show-b {
  border-color: #888 transparent transparent transparent;
  border-style: solid;
  border-width: 5px 4px 0 4px;
  margin-left: -4px;
  margin-top: 10px;
  position: absolute;
}

.fulltext .el-checkbox__label {
  padding-left: 9px !important;
}
</style>
